import React from 'react'
import './index.css';
import Property2 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property2 num="+91-2934572" type="Group Rustic Cabin" desc="Come and enjoy the experience of a group rustic cabin with your group. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "As a group divide the work among ourself from cleaning , washing , taking dog for walk and the others as per the needs." price = "0" guests="4" bed="2"  bath="2" />
    </div>
  )
}

export default Property
